// src/pages/Kontakt.tsx
import { motion } from 'framer-motion';
import { Phone, Mail, MapPin } from 'lucide-react';
import SectionHeading from '@/components/SectionHeading';
import ContactForm from '@/components/ContactForm';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import { Card, CardContent } from '@/components/ui/card';

const Kontakt = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      
      <main className="pt-32">
        {/* Centered Title Section */}
        <div className="container-custom mx-auto mb-12">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-stone-800 mb-4">
              Stopite v stik z nami
            </h1>
            <p className="text-xl md:text-2xl text-stone-600 max-w-3xl mx-auto">
              Odgovorili vam bomo v najkrajšem možnem času
            </p>
          </div>
        </div>

        <section className="py-8">
          <div className="container-custom">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
              <motion.div
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.5 }}
                className="rounded-lg overflow-hidden transition-all duration-300 hover:shadow-[0_0_15px_rgba(240,90,40,0.5)] hover:border-secondary border border-stone-200"
              >
                <Card className="h-full shadow-none border-0">
                  <CardContent className="p-8">
                    <SectionHeading 
                      title="Kontaktni podatki"
                      subtitle="Najdete nas na dveh lokacijah"
                      alignment="left"
                    />
                    
                    <div className="space-y-10 mt-6">
                      <div className="flex items-start gap-4">
                        <div className="w-12 h-12 bg-stone-100 rounded-full flex items-center justify-center shrink-0">
                          <MapPin size={24} className="text-stone-800" />
                        </div>
                        <div>
                          <h3 className="text-xl font-semibold text-stone-800 mb-2">Salon keramike in kamna</h3>
                          <p className="text-stone-600">Ptujska cesta 110</p>
                          <p className="text-stone-600">2000 Maribor</p>
                          <p className="text-stone-600">Slovenija</p>
                        </div>
                      </div>
                      
                      <div className="flex items-start gap-4">
                        <div className="w-12 h-12 bg-stone-100 rounded-full flex items-center justify-center shrink-0">
                          <MapPin size={24} className="text-stone-800" />
                        </div>
                        <div>
                          <h3 className="text-xl font-semibold text-stone-800 mb-2">Proizvodnja</h3>
                          <p className="text-stone-600">Levarska ulica 3</p>
                          <p className="text-stone-600">2314 Zgornja Polskava</p>
                          <p className="text-stone-600">Slovenija</p>
                        </div>
                      </div>
                      
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-stone-100 rounded-full flex items-center justify-center shrink-0">
                          <Phone size={24} className="text-stone-800" />
                        </div>
                        <div>
                          <h3 className="text-xl font-semibold text-stone-800 mb-2">Telefon</h3>
                          <a href="tel:031467272" className="text-stone-600 hover:text-stone-800 transition-colors">031 467 272</a>
                        </div>
                      </div>
                      
                      <div className="flex items-center gap-4">
                        <div className="w-12 h-12 bg-stone-100 rounded-full flex items-center justify-center shrink-0">
                          <Mail size={24} className="text-stone-800" />
                        </div>
                        <div>
                          <h3 className="text-xl font-semibold text-stone-800 mb-2">E-pošta</h3>
                          <a href="mailto:info@kamen.si" className="text-stone-600 hover:text-stone-800 transition-colors">info@kamen.si</a>
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </motion.div>
              
              <motion.div
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.5 }}
                className="rounded-lg overflow-hidden transition-all duration-300 hover:shadow-[0_0_15px_rgba(240,90,40,0.5)] hover:border-secondary border border-stone-200"
              >
                <Card className="h-full shadow-none border-0">
                  <CardContent className="p-8">
                    <SectionHeading 
                      title="Pošljite nam sporočilo"
                      subtitle="Odgovorili vam bomo v najkrajšem možnem času"
                      alignment="left"
                    />
                    
                    <div className="mt-6">
                      <ContactForm />
                    </div>
                  </CardContent>
                </Card>
              </motion.div>
            </div>
            
            <div className="mt-16">
              <h3 className="text-2xl font-semibold text-stone-800 mb-6">Kje nas najdete</h3>
              <div className="rounded-lg overflow-hidden shadow-md h-[400px]">
                <iframe 
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2743.6152422604097!2d15.66103007670284!3d46.54078957123063!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47657faa92fa3e15%3A0x9f740f8ab9cf33cc!2sPtujska%20cesta%20110%2C%202000%20Maribor!5e0!3m2!1sen!2ssi!4v1698755121377!5m2!1sen!2ssi" 
                  width="100%" 
                  height="100%" 
                  style={{ border: 0 }} 
                  allowFullScreen 
                  loading="lazy" 
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Kamen d.o.o. location"
                ></iframe>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Kontakt;